export const Types = {
  FORGOT: 'password/FORGOT',
  PIN: 'password/PIN',
  SUCCESS: 'password/SUCCESS',
};

const INITIAL_STATE = { loading: false, success: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.FORGOT:
      return { ...state, loading: true };
    case Types.PIN:
      return { ...state, loading: true };
    case Types.SUCCESS:
      return { loading: false, success: false };
    default:
      return state;
  }
};

export const Creators = {
  forgot: (place, type) => ({
    type: Types.FORGOT,
    payload: { place, type },
  }),
  checkPin: pin => ({
    type: Types.PIN,
    payload: { pin },
  }),
  success: () => ({ type: Types.SUCCESS }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/password.js